module.exports = __webpack_public_path__ + "static/gift-aid-logo-1d016a4113db100b4cf563cf5828d178.svg";